import breadcrumbTemplate from "../common/breadcrumb/breadcrumb.html";
import contactTypesListTemplate from "./contact_types-list.html";
import contactTypesEditTemplate from "./contact_types-edit.html";

angular.module("contact_types", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('contact_types', {
                url: "/contact_types",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: breadcrumbTemplate,
            })

            .state('contact_types.list', {
                url: "/list",
                controller: "ContactTypesListCtrl",
                template: contactTypesListTemplate,
                requiredPermission: ["CONTACT_TYPES_READ"]
            })            
            .state('contact_types.edit', {
                url: "/edit/:id/:type",
                controller: "ContactTypesEditCtrl",
                template: contactTypesEditTemplate,
                requiredPermission: ["CONTACT_TYPES_READ"]
            })
    }])
;